import { render, staticRenderFns } from "./DraftReport.vue?vue&type=template&id=73c72694&scoped=true"
import script from "./DraftReport.vue?vue&type=script&lang=js"
export * from "./DraftReport.vue?vue&type=script&lang=js"
import style0 from "./DraftReport.vue?vue&type=style&index=0&id=73c72694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c72694",
  null
  
)

export default component.exports